module.exports = __webpack_public_path__ + "static/media/barclay-eagle-labs-logo.13ff42a6.png";